export enum OttopilotAnalyticsWorkspaceCapabilityAccessOperation {
    create = "08582524-ecfe-495e-b3f7-a265da5d71ee",
    read = "6cd143a2-44c2-490f-8990-e06b985b1e25",
    update = "a76d57b5-9ede-4c5e-b3eb-d9796730da2a",
    delete = "927e6724-6601-4ddc-91f0-ee87b96de3b8",
}
